
import axiosInstance from '../common/axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL;


const getSupplierCertificate = async (id) => {
  const res = await axiosInstance.get(`${backendUrl}/api/certificates/${id}`);
  return res.data;
}; 

const saveCertificate = async (data) => {
  const res = await axiosInstance.post(`${backendUrl}/api/certificates`, data);
  return res.data;
};

export const updateCertificate = async (id, data) => {

  const res = await axiosInstance.put(`${backendUrl}/api/certificates/${id}`, data);
  return res.data;
};

 export const fetchSupplierCertificate = async () => {
   
     const res = await axiosInstance.get(`${backendUrl}/api/certificates`);
  return res.data;
  };

 export const deleteSupplierCertificate = async (id) => {
   const res = await axiosInstance.delete(`${backendUrl}/api/certificates/${id}`);
  return res.data;
  }; 


const saveSupplierCertificate = async (data) => {
  const res = await axiosInstance.post(`${backendUrl}/api/certificates/supplier`, data);
  return res.data;
};




export default { getSupplierCertificate, saveCertificate, updateCertificate , fetchSupplierCertificate, deleteSupplierCertificate, saveSupplierCertificate };